module.exports = __webpack_public_path__ + "static/Eagle-1dc3009df996f4dec56192cb1ac4fa20.png";